import { NEWS } from '../config/church'
import type { Screen } from '../core/types'
import { homeBar, pageHeader } from './chrome'

export function createNewsScreen(): Screen {
  return {
    mount(root, ctx) {
      root.classList.add('screen--page')
      root.appendChild(pageHeader('교회 소식', '공지와 행사 안내'))

      const body = document.createElement('div')
      body.className = 'page__body'

      if (NEWS.length === 0) {
        const empty = document.createElement('p')
        empty.className = 'empty'
        empty.textContent = '등록된 소식이 없습니다.'
        body.appendChild(empty)
      }

      for (const item of NEWS) {
        const row = document.createElement('article')
        row.className = 'news-row'

        const title = document.createElement('h2')
        title.className = 'news-row__title'
        title.textContent = item.title

        const date = document.createElement('p')
        date.className = 'news-row__date'
        date.textContent = item.date

        row.append(title, date)
        body.appendChild(row)
      }

      root.appendChild(body)
      root.appendChild(homeBar(ctx.go))
    },
  }
}
